/* DEMONTHA — Sizden Gelenler
   Galeri kategori filtresi + lightbox galerisi + yorum katlama.

   JS ölürse sayfa tam çalışır durumda kalır:
     - filtre çubuğu gizli kalır, 94 karenin hepsi görünür,
     - yorumların TAMAMI açık gelir (katlamayı JS ekler),
     - karelerin bağlantısı normal link olarak görseli açar.
   Görseller loading="lazy" olduğu için gizli hücreler indirilmez. */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-dmt-rev-ready') === 'true') { return; }
    root.setAttribute('data-dmt-rev-ready', 'true');

    /* ---------------- galeri filtresi ---------------- */
    var bar = root.querySelector('[data-dmt-rev-filters]');
    var grid = root.querySelector('[data-dmt-rev-grid]');
    var counter = root.querySelector('[data-dmt-rev-count]');
    var cells = grid ? grid.querySelectorAll('[data-dmt-rev-cat]') : [];

    if (bar && grid && cells.length) {
      bar.hidden = false;
      var chips = bar.querySelectorAll('[data-dmt-rev-chip]');

      var apply = function (key) {
        var shown = 0;
        for (var i = 0; i < cells.length; i++) {
          var match = key === 'all' || cells[i].getAttribute('data-dmt-rev-cat') === key;
          cells[i].hidden = !match;
          if (match) { shown++; }
        }
        for (var j = 0; j < chips.length; j++) {
          var on = chips[j].getAttribute('data-dmt-rev-chip') === key;
          chips[j].setAttribute('aria-pressed', on ? 'true' : 'false');
        }
        grid.setAttribute('data-empty', shown === 0 ? 'true' : 'false');
        if (counter) {
          counter.textContent = counter.getAttribute('data-dmt-rev-count')
            .replace('[n]', String(shown));
        }
        activeKey = key;
        applyChunk();
      };

      for (var k = 0; k < chips.length; k++) {
        chips[k].addEventListener('click', function (event) {
          apply(event.currentTarget.getAttribute('data-dmt-rev-chip'));
        });
      }

      apply('all');
    }

    /* ---------------- galeri parcali gosterim ----------------
       94 karenin tamami DOM'da; fazlasi yalnizca data-chunk-hidden ile
       gizlenir. Kaydirinca IntersectionObserver sonraki partiyi acar, dugme
       de yedek olarak calisir. JS yoksa hicbiri gizlenmez.

       FILTREYLE ILISKI: parca YALNIZCA "Tumu" gorunumunde calisir. Bir
       kategori secilince o kategorinin kareleri tam gosterilir (7 kare icin
       "daha fazla yukle" anlamsiz olurdu) ve dugme gizlenir.

       "Tumu"ye donunce acilmis parti KORUNUR, sifirlanmaz: kullanicinin
       yukleme eylemi bilincli bir tercihtir, filtreye girip cikmak onu geri
       almamali. Kaydirma konumu da boylece anlamli kaliyor. */
    var gridMore = root.querySelector('[data-dmt-rev-grid-more]');
    var sentinel = root.querySelector('[data-dmt-rev-sentinel]');
    var activeKey = 'all';
    var chunkShown = 0;
    var chunkInitial = 24;
    var chunkStep = 24;

    if (grid) {
      chunkInitial = parseInt(grid.getAttribute('data-chunk-initial'), 10) || 24;
      chunkStep = parseInt(grid.getAttribute('data-chunk-step'), 10) || 24;
    }

    function filterMatched() {
      var out = [];
      for (var i = 0; i < cells.length; i++) {
        if (!cells[i].hidden) { out.push(cells[i]); }
      }
      return out;
    }

    function applyChunk() {
      if (!grid || !cells.length) { return; }
      var matched = filterMatched();
      var chunking = activeKey === 'all' && matched.length > chunkInitial;

      if (!chunking) {
        for (var j = 0; j < cells.length; j++) { cells[j].removeAttribute('data-chunk-hidden'); }
        if (gridMore) { gridMore.hidden = true; }
        return;
      }

      if (chunkShown < chunkInitial) { chunkShown = chunkInitial; }
      if (chunkShown > matched.length) { chunkShown = matched.length; }

      for (var k = 0; k < matched.length; k++) {
        if (k < chunkShown) {
          matched[k].removeAttribute('data-chunk-hidden');
        } else {
          matched[k].setAttribute('data-chunk-hidden', '');
        }
      }

      var remain = matched.length - chunkShown;
      if (gridMore) {
        gridMore.hidden = remain <= 0;
        if (remain > 0) {
          gridMore.textContent = (gridMore.getAttribute('data-label') || '')
            .replace('[n]', String(remain));
        }
      }
    }

    function chunkMore() {
      chunkShown += chunkStep;
      applyChunk();
    }

    if (gridMore) {
      gridMore.addEventListener('click', chunkMore);
    }

    /* Kaydirinca kendiliginden yuklensin. rootMargin, kullanici dibe varmadan
       "biraz indikten sonra" bir sonraki partinin hazir olmasini saglar. */
    if (sentinel && typeof window.IntersectionObserver === 'function') {
      var chunkObserver = new window.IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting && gridMore && !gridMore.hidden) {
            chunkMore();
          }
        }
      }, { rootMargin: '600px 0px' });
      chunkObserver.observe(sentinel);
    }

    /* Degiskenler yukarida atandigi icin ilk apply() cagrisinda parca henuz
       hazir degildi; kurulum bitince bir kez daha uygulanir. */
    applyChunk();

    /* ---------------- yorum katlama ----------------
       Yorumların tamamı sayfada basılıdır; fazlası yalnızca gizlenir. */
    var qList = root.querySelector('[data-dmt-rev-quotes]');
    var moreBtn = root.querySelector('[data-dmt-rev-more]');
    if (qList && moreBtn && qList.querySelector('.dmt-rev__quote--extra')) {
      var setMore = function (collapsed) {
        qList.setAttribute('data-collapsed', collapsed ? 'true' : 'false');
        moreBtn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        moreBtn.textContent = moreBtn.getAttribute(collapsed ? 'data-label-more' : 'data-label-less');
      };
      setMore(true);
      moreBtn.hidden = false;
      moreBtn.addEventListener('click', function () {
        var collapsed = qList.getAttribute('data-collapsed') === 'true';
        setMore(!collapsed);
        if (!collapsed && qList.getBoundingClientRect().top < 0) {
          qList.scrollIntoView({ block: 'start', behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
        }
      });
    }

    /* ---------------- lightbox galerisi ---------------- */
    var lb = root.querySelector('[data-dmt-rev-lb]');
    if (!lb) { return; }

    var lbImg = lb.querySelector('[data-dmt-rev-lb-img]');
    var lbClose = lb.querySelector('[data-dmt-rev-lb-close]');
    var lbPrev = lb.querySelector('[data-dmt-rev-lb-prev]');
    var lbNext = lb.querySelector('[data-dmt-rev-lb-next]');
    var lbCount = lb.querySelector('[data-dmt-rev-lb-count]');
    var lbFig = lb.querySelector('.dmt-rev__lb-fig');
    var set = [];
    var idx = -1;
    var lastFocus = null;

    /* Gezinme YALNIZCA o an görünen filtre kümesi içindedir: "Kitaplık"
       seçiliyken 7 kare arasında gezilir ve sayaç 7 üzerinden sayar. */
    function visibleTriggers() {
      var out = [];
      for (var i = 0; i < cells.length; i++) {
        if (cells[i].hidden) { continue; }
        var a = cells[i].querySelector('[data-dmt-rev-zoom]');
        if (a) { out.push(a); }
      }
      return out;
    }

    /* Yalnızca BİR önceki ve BİR sonraki ön yüklenir. Bu kod ancak lightbox
       açıldığında çalıştığı için açılıştaki tembel yükleme bozulmaz. */
    function preload(i) {
      if (i < 0 || i >= set.length) { return; }
      var im = new Image();
      im.src = set[i].getAttribute('href');
    }

    function show(i) {
      if (i < 0 || i >= set.length) { return; }
      idx = i;
      var a = set[i];
      var img = a.querySelector('img');
      /* Gezinme kumesi FILTREYE gore kurulur, parcaya gore degil: kullanici
         lightbox'ta 94 karenin tamamini gezebilir ve sayac "15 / 94" der.
         Henuz acilmamis bir kareye gelinirse o kareyi kapsayacak kadar parti
         acilir; boylece lightbox kapandiginda kare izgarada da gorunur. */
      var cell = a.parentNode;
      while (cell && !cell.hasAttribute('data-dmt-rev-cat')) { cell = cell.parentNode; }
      if (cell && cell.hasAttribute('data-chunk-hidden')) {
        var need = i + 1;
        var guard = 0;
        while (chunkShown < need && guard < 200) { chunkShown += chunkStep; guard++; }
        applyChunk();
      }
      lbImg.setAttribute('src', a.getAttribute('href'));
      lbImg.setAttribute('alt', img ? (img.getAttribute('alt') || '') : '');
      if (lbCount) { lbCount.textContent = (i + 1) + ' / ' + set.length; }
      /* Uçlarda ok gizlenmez, DEVRE DIŞI kalır: yerleşim zıplamaz ve
         kullanıcı kümenin bittiğini görür. Döngü bilinçli olarak yok. */
      if (lbPrev) { lbPrev.disabled = i <= 0; }
      if (lbNext) { lbNext.disabled = i >= set.length - 1; }
      preload(i - 1);
      preload(i + 1);
    }

    function move(step) {
      var next = idx + step;
      if (next < 0 || next >= set.length) { return; }
      show(next);
    }

    function close() {
      lb.setAttribute('data-open', 'false');
      lb.setAttribute('aria-hidden', 'true');
      if (lbImg) { lbImg.removeAttribute('src'); }
      if (lbCount) { lbCount.textContent = ''; }
      idx = -1;
      if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
    }

    function open(trigger) {
      set = visibleTriggers();
      var at = -1;
      for (var i = 0; i < set.length; i++) {
        if (set[i] === trigger) { at = i; break; }
      }
      if (at < 0) { return; }
      lastFocus = trigger;
      lb.setAttribute('data-open', 'true');
      lb.setAttribute('aria-hidden', 'false');
      show(at);
      if (lbClose && lbClose.focus) { lbClose.focus(); }
    }

    var links = root.querySelectorAll('[data-dmt-rev-zoom]');
    for (var m = 0; m < links.length; m++) {
      links[m].addEventListener('click', function (event) {
        event.preventDefault();
        open(event.currentTarget);
      });
    }

    if (lbClose) { lbClose.addEventListener('click', close); }
    if (lbPrev) { lbPrev.addEventListener('click', function () { move(-1); }); }
    if (lbNext) { lbNext.addEventListener('click', function () { move(1); }); }

    lb.addEventListener('click', function (event) {
      if (event.target === lb || event.target === lbFig) { close(); }
    });

    document.addEventListener('keydown', function (event) {
      if (lb.getAttribute('data-open') !== 'true') { return; }
      if (event.key === 'Escape') {
        close();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        move(1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        move(-1);
      }
    });

    /* Mobilde parmakla kaydırma. Dikey kaydırmayı bozmamak için yalnızca
       yatay baskın hareketler sayılır (eşik 40px). */
    var tX = 0;
    var tY = 0;

    lb.addEventListener('touchstart', function (event) {
      if (!event.changedTouches || !event.changedTouches.length) { return; }
      tX = event.changedTouches[0].clientX;
      tY = event.changedTouches[0].clientY;
    }, { passive: true });

    lb.addEventListener('touchend', function (event) {
      if (!event.changedTouches || !event.changedTouches.length) { return; }
      var dx = event.changedTouches[0].clientX - tX;
      var dy = event.changedTouches[0].clientY - tY;
      if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) { return; }
      move(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  function init(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    var roots = container.querySelectorAll('[data-dmt-rev-root]');
    for (var i = 0; i < roots.length; i++) { initRoot(roots[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
